import { render, staticRenderFns } from "./CrlvHint.vue?vue&type=template&id=436e47a2&scoped=true&"
import script from "./CrlvHint.vue?vue&type=script&lang=js&"
export * from "./CrlvHint.vue?vue&type=script&lang=js&"
import style0 from "./CrlvHint.vue?vue&type=style&index=0&id=436e47a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e47a2",
  null
  
)

export default component.exports